import React, { useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { scrollToTop } from '../../HelperFunction';
import Header from '../Header';
import { MaterialButton } from '../MaterialUI';
import MenuHeader from '../MenuHeader';
import './style.css';

export default function Layout(props) {
	useEffect(() => {
		window.onscroll = function() {
			scrollFunction();
		};

		var mybutton = document.getElementById('scrollBtn');
		// mybutton.innerText = 'Miss You';
		// console.log({ mybutton });

		function scrollFunction() {
			if (document.body.scrollTop > 900 || document.documentElement.scrollTop > 900) {
				mybutton.style.display = 'block';
			} else {
				mybutton.style.display = 'none';
			}
		}
	}, []);

	return (
		<React.Fragment>
			<Header handleSearch={props.handleSearch} searchText={props.searchText}  />

			<MenuHeader />

			{props.children}

			<MaterialButton
				title="Naviguer en Haut"
				btnId="scrollBtn"
				icon={<FaArrowUp />}
				onClick={scrollToTop}
				style={{
					position: 'fixed',
					width: '230px',
					border: 'none',
					right: '20px',
					bottom: '20px',
					overflow: 'hidden',
					fontSize: '15px',
					zIndex: 999
					// transition: 'opacity .6s ease-in-out'
				}}
			/>
		</React.Fragment>
	);
}
